<app-project-settings-layer-detail-template
    [businessIdentifier]="layerBloc.value()!.businessIdentifier ?? '-'"
    [canDelete]="canDelete()"
    [canEditSymbology]="!hasStandard()"
    [deleteTooltip]="deleteTooltip()"
    [hasAttributes]="true"
    [subtitle]="labelByLayerType[Layer.TypeEnum.TABLE] | transloco: { COUNT: 1 }"
    [symbologyDisabledTooltip]="hasStandard() ? 'standardizedLayerSymbologyNotEditable' : undefined"
    [title]="layerBloc.value()?.name ?? ''"
    (deleteLayer)="deleteLayer(layerBloc.value()!.id)"
    (goToPreviousPage)="closeDetail(layerBloc.value()!.id)">
    <section attributesBookmarked>
        @if (isLoading()) {
            <app-loading
                class="m-auto"
                size="30" />
        } @else if (attributesBookmarked()) {
            <app-layer-data-attributes-list [dataAttributes]="attributesBookmarked()!" />
        } @else {
            <app-no-data-to-display
                displayedMessage="noAttribute"
                iconSize="4x" />
        }
    </section>

    <section attributesOther>
        @if (isLoading()) {
            <app-loading
                class="m-auto"
                size="30" />
        } @else if (attributesOther()) {
            <app-layer-data-attributes-list [dataAttributes]="attributesOther()!" />
        } @else {
            <app-no-data-to-display
                displayedMessage="noAttribute"
                iconSize="4x" />
        }
    </section>
</app-project-settings-layer-detail-template>
